import type { ReactNode } from 'react';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';

import { Gavi } from '#components/mobile/travesia/Gavi';
import type { GaviEstado } from '#components/mobile/travesia/Gavi';
import { color, texto } from '#components/mobile/ui/tokens';

type BocadilloGaviProps = {
  children: ReactNode;
  estado?: GaviEstado;
  /** Para la ayuda de Gavi y las pruebas. */
  testId?: string;
  /** Qué fallo cuenta (la ayuda explica ese). */
  ayudaError?: string;
};

/** Gavi a la izquierda y lo que dice en un bocadillo (como en la travesía). */
export function BocadilloGavi({
  children,
  estado,
  testId,
  ayudaError,
}: BocadilloGaviProps) {
  return (
    <View
      style={{ flexDirection: 'row', gap: 10, alignItems: 'flex-start' }}
      data-testid={testId}
      data-ayuda-error={ayudaError}
    >
      <Gavi estado={estado} ancho={48} style={{ flexShrink: 0 }} />
      <Text
        style={{
          ...texto.cuerpo,
          flex: 1,
          backgroundColor: color.surface,
          color: color.fg,
          borderRadius: '4px 18px 18px 18px',
          padding: '10px 14px',
        }}
      >
        {children}
      </Text>
    </View>
  );
}
